import { isUnitAttributeNode } from '../richText/helpers.no-deps'
import type { Expression } from './Expression.no-deps'
import { stepsElements, type TraverseOptions, walkSteps } from './generators.no-deps'
import { type HasSteps, textContentHasRichText, isConcreteStep } from './types.no-deps'

/**
 * Find all the references to unit attributes in a flow
 * Used to find out which data to cache when starting a report
 */
export function findDataAttributeNames(section: HasSteps, opts?: TraverseOptions) {
    const attributeNames: string[] = []

    for (const step of walkSteps(opts)(section)) {
        if (!isConcreteStep(step)) {
            continue
        }

        for (const route of step.conditionalRoutes) {
            if (route.type === 'UnitDataConditionalRoute') {
                attributeNames.push(route.variableName)
                continue
            }

            if (route.condition.type === 'NumberRouteCondition') {
                attributeNames.push(...attributesInExpression(route.condition.expression))
                continue
            }
        }

        for (const element of stepsElements(step)) {
            if (element.type === 'calculation') {
                attributeNames.push(...attributesInExpression(element.formula))
                continue
            }

            if (element.type === 'text-content' && textContentHasRichText(element)) {
                for (const paragraph of element.richText) {
                    for (const node of paragraph.children) {
                        if (!isUnitAttributeNode(node)) continue
                        attributeNames.push(node.name)
                    }
                }
            }
        }
    }

    return attributeNames
}

function attributesInExpression(expression: Expression): string[] {
    if (expression.type === 'constant') return []
    if (expression.type === 'element') return []
    if (expression.type === 'unit-data-variable') return [expression.variableName]
    if (expression.type === 'operator') {
        return [...attributesInExpression(expression.left), ...attributesInExpression(expression.right)]
    }
}
